import { NavLink, Outlet, Link } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  UsersRound,
  Tag,
  ShoppingBag,
  Package,
  Truck,
  Settings as SettingsIcon,
  ExternalLink,
  Store,
} from "lucide-react";

const nav = [
  { to: "/", icon: LayoutDashboard, label: "Dashboard", testId: "nav-dashboard" },

  { to: "/customers", icon: Users, label: "Customers", testId: "nav-customers" },

  { to: "/groups", icon: UsersRound, label: "Customer Groups", testId: "nav-groups" },

  { to: "/pricing-rules", icon: Tag, label: "Pricing Rules", testId: "nav-pricing" },

  { to: "/order-limits", icon: ShoppingBag, label: "Order Limits", testId: "nav-order-limits" },

  { to: "/product-limits", icon: Package, label: "Product Limits", testId: "nav-product-limits" },

  { to: "/shipping-rules", icon: Truck, label: "Shipping Rules", testId: "nav-shipping" },

  // ✅ NEW PAGE
  { to: "/wholesale-products", icon: Package, label: "Wholesale Products", testId: "nav-wholesale-products" },

  { to: "/settings", icon: SettingsIcon, label: "Settings", testId: "nav-settings" },
];

export default function Layout() {
  return (
    <div className="min-h-screen flex" data-testid="app-layout">
      <aside
        className="w-64 flex-shrink-0 text-white flex flex-col"
        style={{ background: "var(--brand-navy)" }}
        data-testid="sidebar"
      >
        <div className="px-5 py-5 border-b border-white/10 flex items-center gap-3">
          <div
            className="w-9 h-9 rounded-lg flex items-center justify-center font-bold text-sm"
            style={{ background: "var(--brand-yellow)", color: "#1a2340" }}
          >
            V
          </div>
          <div>
            <div className="text-sm font-semibold leading-tight">V-VENTURE</div>
            <div className="text-[11px] text-white/60 leading-tight">Wholesale B2B</div>
          </div>
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => `sidebar-item ${isActive ? "active" : ""}`}
              data-testid={item.testId}
            >
              <item.icon size={18} strokeWidth={1.75} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
            
        <div className="px-4 py-4 border-t border-white/10">
          <Link
            to="/register"
            target="_blank"
            className="flex items-center justify-between text-[12px] text-white/80 hover:text-white"
            data-testid="link-registration-form"
          >
            <span className="flex items-center gap-2">
              <Store size={14} /> Public Registration
            </span>
            <ExternalLink size={12} />
          </Link>

         
        </div>

      </aside>

      <main className="flex-1 overflow-y-auto">
        <div className="max-w-[1200px] mx-auto px-8 py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
